import { 
    GAME_FACT_COMMENT,
    GAME_FACT_HANDBALL_STOP,
    GAME_FACT_HANDBALL_GOAL,
    GAME_FACT_HANDBALL_PENALTY,
    GAME_FACT_HANDBALL_SHOOTOUT,
    GAME_FACT_HANDBALL_YELLOWCARD,
    GAME_FACT_HANDBALL_REDCARD,
    GAME_FACT_HANDBALL_TIMEOUT,
    GAME_FACT_HANDBALL_TURNOVER,
    GAME_FACT_HANDBALL_TWOMIN_SUSPENSION,
    GAME_FACT_HANDBALL_STAR
} from '../../constants.js'
import { GoalDto } from '../../gamefacts/handball/GoalDto.js'
import { PenaltyDto } from '../../gamefacts/handball/PenaltyDto.js'
import { StopDto } from '../../gamefacts/handball/StopDto.js'
import { ShootoutPenaltyDto } from '../../gamefacts/handball/ShootoutPenaltyDto.js'
import { YellowCardDto } from '../../gamefacts/handball/YellowCardDto.js'
import { TwoMinSuspension } from '../../gamefacts/handball/TwoMinSuspension.js'
import { RedCardDto } from '../../gamefacts/handball/RedCardDto.js'
import { TimeoutDto } from '../../gamefacts/handball/TimeoutDto.js'
import { TurnOverDto } from '../../gamefacts/handball/TurnOverDto.js'
import { CommentDto } from '../../gamefacts/handball/CommentDto.js.js'
import { StarDto } from '../../gamefacts/handball/StarDto.js'

export const handballResolvers = {
    [GAME_FACT_HANDBALL_STOP]: (event) => new StopDto(event),
    [GAME_FACT_HANDBALL_GOAL]: (event) => new GoalDto(event),
    [GAME_FACT_HANDBALL_PENALTY]: (event) => new PenaltyDto(event),
    [GAME_FACT_HANDBALL_SHOOTOUT]: (event) => new ShootoutPenaltyDto(event),
    [GAME_FACT_HANDBALL_YELLOWCARD]: (event) => new YellowCardDto(event),
    [GAME_FACT_HANDBALL_REDCARD]: (event) => new RedCardDto(event),
    [GAME_FACT_HANDBALL_TWOMIN_SUSPENSION]: (event) => new TwoMinSuspension(event),
    [GAME_FACT_HANDBALL_TIMEOUT]: (event) => new TimeoutDto(event),
    [GAME_FACT_HANDBALL_TURNOVER]: (event) => new TurnOverDto(event),
    [GAME_FACT_HANDBALL_STAR]: (event) => new StarDto(event),
    [GAME_FACT_COMMENT]: (event) => new CommentDto(event),
}